import React from 'react';

import classnames from 'classnames/bind';
import styles from './listWrapper.module.scss';
const cx = classnames.bind(styles);

interface InfoWrapperProps {
  children: React.ReactNode;
}

const InfoWrapper = (props: InfoWrapperProps) => {
  const { children } = props;

  return <div className={cx('wrapper')}>{children}</div>;
};

export default InfoWrapper;
